import { useTranslation } from 'react-i18next'
import React from 'react'

import useSsoLoginRequest from '../login/_requests/ssoLoginRequest'
import Center from '../../../packages/kiti/components/helpers/Center'
import IconBlock from '../../../components/presentation/IconBlock'

const AuthWithSSOToken = ({ ssoToken, userId }) => {
  const { t } = useTranslation('session')
  const [loginRequest] = useSsoLoginRequest(ssoToken, userId)

  const browserEvent = {
    preventDefault: () => {}
  }
  loginRequest(browserEvent)

  return (
    <div>
      <Center flex={1} minHeight="100vh">
        <IconBlock icon="RiLoginBoxLine" title={t('ssoLogin')} subtitle={t('ssoLoginRedirectMessage')} />
      </Center>
    </div>
  )
}

export default AuthWithSSOToken
